const API_BASE_URL = process.env.REACT_APP_API_URL ||"https://stage.getrevibe.app/api";

export const fetchVideosAPI = async (pageNum = 1, limit = 6, search = "") => {
  const token = localStorage.getItem("authToken");
  
  const response = await fetch(
    `${API_BASE_URL}/video?sortOrder=desc&page=${pageNum}&limit=${limit}&search=${search}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  
  return response.json();
};